import { OralQueryModel } from "../pages/main/query/oral/activesOral/oral.query.model";
import { QueryModel } from "../pages/main/query/query.model";
import { ProductModel } from "../models/Product.model";

const queryModel = 'query-model'
const oralQuery = 'oral-query'
const notifyFormula = 'notify-formula'
const preselectProducts = 'preselect-products'

export const getQuery = () => {
    const json = sessionStorage.getItem(queryModel);
    return JSON.parse(json || '{}') as QueryModel
}

export const getOralQuery = () => {
    const json = sessionStorage.getItem(oralQuery);
    return JSON.parse(json || '{}') as OralQueryModel
}

export const setQuery = (newState: any) => {
    const updated = {
        ...getQuery(),
        ...newState
    } as QueryModel
    sessionStorage.setItem(queryModel, JSON.stringify(updated))
}

export const setOralQuery = (newState: any) => {
    const updated = {
        ...getOralQuery(),
        ...newState
    } as OralQueryModel
    sessionStorage.setItem(oralQuery, JSON.stringify(updated))
}

export const clearQuery = () => {
    sessionStorage.setItem(queryModel, "")
}

export const clearOralQuery = () => {
    sessionStorage.setItem(oralQuery, "")
}

/**
 * Produtos pré-selecionados ao iniciar uma consulta a partir da biblioteca de Ativos
 * ("usar em nova consulta"). Chave própria porque sobrevive ao clearQuery do passo de paciente;
 * é consumida (lida e limpa) no passo de Produtos.
 */
export const setPreselectProducts = (products: ProductModel[]) => {
    sessionStorage.setItem(preselectProducts, JSON.stringify(products))
}

export const getPreselectProducts = () => {
    const json = sessionStorage.getItem(preselectProducts)
    return JSON.parse(json || '[]') as ProductModel[]
}

export const clearPreselectProducts = () => {
    sessionStorage.removeItem(preselectProducts)
}

export const setNotifyFormula = (notify: boolean) => {
    sessionStorage.setItem(notifyFormula, notify ? 'true' : 'false')
}

export const getNotifyFormula = () => {
    const notify = sessionStorage.getItem(notifyFormula)
    return notify === 'true'
}
